export default async function postHighFives(h5Form) {
  const responses = await Promise.all(
    h5Form.recipientEmailList.map(async userEmail => {
      const h5 = Object.assign({}, h5Form, {
        recipientEmail: userEmail,
        recipient: ''
      });
      const res = await window.fetch(process.env.REACT_APP_SUBMISSION_API, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.sessionStorage.accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(h5)
      });
      return res.json();
    })
  );
  return responses;
}



// WEBPACK FOOTER //
// ./src/containers/SubmitForm/postHighFives.js